export default __webpack_public_path__ + "static/media/school-generateImg1.1884d5de.jpg";